 const transcribeAudio = async (blob_str) => {
    
    const formdata = new FormData();
    formdata.append('audio', blob_str, 'audio.wav');

    try {
      const res = await fetch('https://vosk-st.aigmapte.com/transcribe', {
        method: 'POST',
        body: formdata,
      });

      if (!res.ok) {
        throw new Error('Network response was not ok');
      }

      const res_json = await res.json();
    //   setTranscript(res_json.text);
    //   console.log("python response", res_json.text);

      return res_json.text;

    } catch (error) {
      console.error("Error during transcription:", error);
     
      // throw error; // Re-throw the error if you want calling functions to handle it as well
    }
  };

  export default transcribeAudio;